import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import UserTable from '../../../components/tables/UserTable';

const generateSampleData = (count = 50) => {
  const statuses = ['Active', 'Inactive'];
  const zones = [
    'North Zone',
    'South Zone',
    'East Zone',
    'West Zone',
    'Central Zone'
  ];
  const cities = [
    'Mumbai',
    'Delhi',
    'Bangalore',
    'Hyderabad',
    'Chennai',
    'Kolkata',
    'Pune',
    'Ahmedabad',
    'Jaipur',
    'Lucknow',
    'Surat',
    'Indore',
    'Nagpur'
  ];

  return Array.from({ length: count }, (_, index) => {
    const joinDate = new Date(
      2020 + Math.floor(Math.random() * 5),
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1
    )
      .toISOString()
      .split('T')[0];

    return {
      id: `DST${String(index + 1).padStart(4, '0')}`,
      name: `Distributor ${index + 1}`,
      email: `distributor${index + 1}@network.com`,
      phone: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      city: cities[Math.floor(Math.random() * cities.length)],
      zone: zones[Math.floor(Math.random() * zones.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      joinDate
    };
  });
};

const UserManagementDistributor = () => {
  const [distributorData, setDistributorData] = useState(() => generateSampleData());

  const handleDataChange = (updatedData) => {
    setDistributorData(updatedData);
  };

  return (
    <Container fluid>
      <UserTable
        data={distributorData}
        userRole="Distributor"
        onDataChange={handleDataChange}
        extraColumns={[
          {
            key: 'zone',
            label: 'Zone',
          },
        ]}
      />
    </Container>
  );
};

export default UserManagementDistributor;


